import React, {Component} from 'react';
import {Form, Row, Modal} from "react-bootstrap";
import {Button} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {showAxiosError} from "../../../helper/helper";


class UpdateDocHeader extends Component {
    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
        this.updateHeader = this.updateHeader.bind(this);
        this.state = {
            requestData: "",
            headerRecordId: "",

        }


    }

    onChangeText(e) {
        let self = this;
        self.setState({requestData: e.target.value})
    }


    updateHeader( documentationRecordId, sectionDataRecordId) {
        let self = this;
        let url;
        let tempData;
        let name = this.state.requestData;
        if (name !== null && name !== "") {
            if (sectionDataRecordId != null) {
                tempData = sectionDataRecordId;
                url = '/servicedocumentation/updateSection' ;
            } else {
                tempData = documentationRecordId;
                url = '/servicedocumentation/updateDocumentation'
            }
            let params = {
                url: url,
                method: 'post',

                data: {
                    recordId: tempData,
                    name: name
                }
            };
            request(params)
                .then(function (response) {
                    Alert.success('Veriler başarıyla gönderildi !', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    self.props.refresh();
                }).catch(function (error) {
                    showAxiosError(error);
                });
        }
    }

    submitForm(event) {
       let self=this;
        self.updateHeader(self.props.docId,self.props.sectionId);
        event.preventDefault();
    }


    render() {


        return (


            <div>
                <Modal show={true}
                       animation={true}
                       modalTransition={{timeout: 700}}
                       dialogClassName="modal-90w"
                       size={"lg"}
                       backdropTransition={{timeout: 1300}}
                       aria-labelledby="example-custom-modal-styling-title"
                       backdrop="static">
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {this.props.headerTitle} Düzenle
                            <div className=".col-12 .col-md-8">
                                <div className=".col-6 .col-md-4" style={{top: "0"}}>
                                    <p style={{display: "inline", fontWeight: 200}}></p>

                                    <button type="button"
                                            onClick={() => this.props.onClickStatus("",null)}

                                            className="close pull-right"
                                            title="Kapat"
                                            aria-label="Kapat">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{height: "350px"}}>
                        <Form onSubmit={this.submitForm}>
                            <Row>

                                <div className="formDiv">
                                    <h2>{this.props.headerTitle}</h2>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Adı</Form.Label>
                                        <Form.Control type="text" onChange={(e) => this.onChangeText(e)} defaultValue={this.props.defaultData}
                                        />
                                    </Form.Group>

                                </div>
                            </Row>
                            <Row>
                                <Button variant="primary" size="lg" type="submit"
                                        style={{margin: "auto", marginTop: "20px"}}>Gönder</Button>
                            </Row>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }

}

export default UpdateDocHeader;